import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppModule } from '../../../app-module';
import { AlertComponent } from '../../../commons/components/alert/alert.component';
import { AuthService } from '../../../commons/services/auth.service';
import { AlertService } from '../../../commons/components/alert/alert.service';
import { ChangePassIniCommand } from '../../../commons/class/user.class';
import { IpService } from '../../../commons/services/ipService.service';

@Component({
    selector: 'oaj-change-pass-ini-itx',
    templateUrl: './changePassIni.component.html',
    styleUrls: ['./changePassIni.component.css'],
    imports: [AppModule, AlertComponent],
    providers: [AuthService, AlertService]
})
export class ChangePassIniComponent implements OnInit {
    changePassForm: FormGroup;
    submitted = false;
    loading = false;
    fieldTextType = false;
    fieldTextType2 = false;
    fieldTextType3 = false;
    reiniciando = false;
    chkTerCon = false;
    chkAviPriv = false;
    private ip = '';

    private formBuilder: FormBuilder = inject(FormBuilder);
    private alertService: AlertService = inject(AlertService);
    private authService: AuthService = inject(AuthService);
    private changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);
    private ipService = inject(IpService);

    constructor() {
        this.changePassForm = this.formBuilder.group({
            currentPassword: ['', Validators.required],
            newPassword: ['', [Validators.required, Validators.minLength(12)]],
            confirmPassword: ['', Validators.required],
            chkAviPriv: [false],
            chkTerCon: [false]
        });
    }
    ngOnInit(): void {
        this.ipService.getIPAddressPromise().then(
            (response) => {
                this.ip = response;
            }
        );
    }

    get f() {
        return this.changePassForm.controls;
    }


    toggleFieldTextType() {
        this.fieldTextType = !this.fieldTextType;
    }
    toggleFieldTextTypeDos() {
        this.fieldTextType2 = !this.fieldTextType2;
    }
    toggleFieldTextTypeTres() {
        this.fieldTextType3 = !this.fieldTextType3;
    }

    /**
     * Funcion para enviar el formulario de cambio de contraseña inicial, se validan los campos del formulario y se llama al servicio de autenticación para cambiar la contraseña del usuario, se muestra un mensaje de éxito o error dependiendo del resultado de la operación
     * @returns 
     */
    onSubmit() {
        this.submitted = true;
        if (this.changePassForm.invalid) {
            return;
        }
        this.loading = true;

        // Validate that new password and confirm password match
        if (this.changePassForm.get('newPassword')?.value !== this.changePassForm.get('confirmPassword')?.value) {
            this.alertService.warn("Las contraseñas no coinciden", { autoClose: true, keepAfterRouteChange: false });
            this.loading = false;
            return;
        }
        
        try {
            const changePassCommand = new ChangePassIniCommand();
            changePassCommand.currentPassword = this.f['currentPassword'].value;
            changePassCommand.newPassword = this.f['newPassword'].value;
            changePassCommand.User = this.authService.getUserName();
            changePassCommand.IdUser = this.authService.getIdUser();
            changePassCommand.sIP = this.ip;

            this.authService.changeInitialPassword(changePassCommand).subscribe({
                next: (response: any) => {
                    if (response?.success || response?.succcess) {
                        this.alertService.success("Contraseña cambiada exitosamente", { autoClose: true, keepAfterRouteChange: false });
                        this.changePassForm.reset();
                        this.submitted = false;
                        this.loading = false;
                        setTimeout(() => {
                            this.reiniciando = true;
                            this.changeDetectorRef.detectChanges();
                            setTimeout(() => {
                                this.authService.logout();
                            }, 4000);
                        }, 1000);
                    }
                    else {
                        this.alertService.error(response?.message || 'Error al cambiar la contraseña', { autoClose: true, keepAfterRouteChange: false });
                        this.loading = false;
                    }
                    this.changeDetectorRef.detectChanges();
                },
                error: (error) => {
                    // console.error('Error al cambiar contraseña:', error);
                    this.alertService.error('Error: ' + (error?.message || error), { autoClose: true, keepAfterRouteChange: false });
                    this.submitted = false;
                    this.loading = false;
                    this.changeDetectorRef.detectChanges();
                },
                complete: () => {
                    this.loading = false;
                    this.changeDetectorRef.detectChanges();
                }
            });
        } catch (error) {
            // console.error('Error inesperado:', error);
            this.alertService.error('Error inesperado al procesar la solicitud: ' + error, { autoClose: true, keepAfterRouteChange: false });
            this.loading = false;
            this.submitted = false;
            this.changeDetectorRef.detectChanges();
        }
    }


    /**
     * Funcion para cerrar la sesión del usuario, se llama a la función logout del servicio de autenticación para eliminar la información de autenticación del usuario y redirigirlo a la página de login
     */
    logout() {
        this.authService.logout();
    }
}